import * as React from "react";
import { connect } from "react-redux";
import * as toastr from "toastr";

import { IState } from "../../classes/state";

import { SearchToolbar } from "./SearchToolbar";

import * as actions from "../../actions/searchToolbarActions";

export class SearchToolbarContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);

    const searchText = this.props.searchToolbar.searchText;
    const selectedSearchFilterValue = this.props.searchToolbar.selectedSearchFilterValue;
    const selectedSearchCategoryValue = this.props.searchToolbar.selectedSearchCategoryValue;

    this.state = {
      searchText,
      selectedSearchFilterValue,
      selectedSearchCategoryValue,
    };

    this.updateSearchTextInLocalState = this.updateSearchTextInLocalState.bind(this);
    this.updateSearchFilterValueInLocalState = this.updateSearchFilterValueInLocalState.bind(this);
    this.updateSearchCategoryValueInLocalState = this.updateSearchCategoryValueInLocalState.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.resetSearchSettings = this.resetSearchSettings.bind(this);
  }

  public updateSearchTextInLocalState(event) {
    const searchText = event.target.value;
    return this.setState({ searchText });
  }

  public updateSearchFilterValueInLocalState(event) {
    event.preventDefault();
    const selectedValue: string = event.currentTarget.attributes["data-value"].value;
    return this.setState({ selectedSearchFilterValue: selectedValue });
  }

  public updateSearchCategoryValueInLocalState(event) {
    event.preventDefault();
    const selectedValue: string = event.currentTarget.attributes["data-value"].value;
    return this.setState({ selectedSearchCategoryValue: selectedValue });
  }

  public setSearch(event) {
    event.preventDefault();
    this.props.setSearch(this.state.searchText, this.state.selectedSearchFilterValue, this.state.selectedSearchCategoryValue);
    // toastr.success("Search settings updated");
  }

  public resetSearchSettings(event) {
    event.preventDefault();
    this.setState({ searchText: "", selectedSearchFilterValue: "", selectedSearchCategoryValue: "" });
    this.props.setSearch("", "", "");
    // toastr.success("Search settings reset");
  }

  public render() {

    const text = this.props.text;
    const filterOptions = this.props.searchToolbar.searchFilterOptions;
    const categoryOptions = this.props.searchToolbar.searchCategoryOptions;
    const portletInstanceId = this.props.portletInstanceId;

    return (
        <SearchToolbar
          filterOptions={filterOptions}
          categoryOptions={categoryOptions}
          searchText={this.state.searchText}
          filterSelectedValue={this.state.selectedSearchFilterValue}
          categorySelectedValue={this.state.selectedSearchCategoryValue}
          text={text}
          portletInstanceId={portletInstanceId}
          onFilterItemSelected={this.updateSearchFilterValueInLocalState}
          onChangeSearchText={this.updateSearchTextInLocalState}
          onCategoryItemSelected={this.updateSearchCategoryValueInLocalState}
          onRunSearch={this.setSearch}
          onResetSearchSettings={this.resetSearchSettings}
        />
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    portletInstanceId: state.calendarSettings.portletInstanceId,
    searchToolbar: state.searchToolbar,
    text: state.text,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    setSearch: (searchText: string, searchFilter: string, searchCategory: string) => {
      const action = actions.setSearch({ searchText, searchFilter, searchCategory });
      dispatch(action);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchToolbarContainer);
